import {
  Heading,
  Stack,
  Tabs,
  TabList,
  Tab,
  Text,
  TabPanel,
  TabPanels,
  Button,
} from '@chakra-ui/react'
import _pickby from 'lodash/pickBy'
import _identity from 'lodash/identity'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useNavigate, useParams } from 'react-router-dom'
import { routes } from 'src/lib/routes'
import { useHotkeys } from 'react-hotkeys-hook'
import moment from 'moment'
import { motion, AnimatePresence } from 'framer-motion'
const MotionStack = motion(Stack)

import LogCell from 'src/components/LogCell'
import SchoolDash from 'src/components/SchoolCell/SchoolDash'
import SupportLoginCell from 'src/components/SupportLoginCell'
import CellLoading from 'src/components/CellLoading'
import SchoolSitesCell from 'src/components/SchoolSitesCell'
import SchoolEditModal from 'src/components/SchoolCell/SchoolEditModal'
import hotkeys from 'src/lib/hotkeys'
import { gql } from '@apollo/client'

export const QUERY = gql`
  query SchoolDashQuery($id: Int!) {
    dashboard: schoolDash(id: $id) {
      school {
        id
        name: schoolName
        subdomain
        edu_domain
        usedForTesting
        acronym
        package
        phone
        googlePlaceUrl
        googlePlaceId
        dormant
        useNewFront
        createdAt
      }
      contents {
        type
        count
      }
      people {
        type
        count
      }
      people30days {
        type
        count
      }
    }
  }
`

export const beforeQuery = (props) => {
  const id = Number(props.id)
  return { variables: { id }, fetchPolicy: 'cache-first' }
}

export const Success = ({ dashboard = {} }) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const search = searchParams.get('search')
  const editSchool = searchParams.get('editSchool')
  const [login, setLogin] = useState(false)
  const [threelogin, setThreeLogin] = useState(false)
  const isOpen = editSchool === 'true' || false
  const tabs = ['Overview', 'Log', 'Sites']
  const {
    school = {},
    contents = [],
    people = [],
    people30days = [],
  } = dashboard
  let rightArrow = '\u2794'

  const handleTabChange = (idx) => {
    const newParams = new URLSearchParams(searchParams)
    if (idx > 0) {
      newParams.set('tab', idx)
    } else {
      newParams.delete('tab')
    }
    if (search) {
      newParams.set('search', search)
    }
    setSearchParams(newParams)
  }

  /* hot-keys definitions for schoolCell */

  for (let idx = 0; idx < tabs.length; idx++) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useHotkeys(hotkeys.tabChange(idx), (e) => {
      e.preventDefault()
      handleTabChange(idx)
    })
  }
  useHotkeys(
    hotkeys.login,
    () => {
      setLogin(true)
      setTimeout(() => setLogin(false), 3000)
    },
    { enableOnTags: ['INPUT'] }
  )

  useHotkeys(
    hotkeys.openEdit,
    (e) => {
      e.preventDefault()
      openEdit()
    },
    { enableOnTags: ['INPUT'] }
  )

  const openEdit = () => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set('editSchool', 'true')
    setSearchParams(newParams)
  }

  const handleClose = () => {
    const newParams = new URLSearchParams(searchParams)
    newParams.delete('editSchool')
    setSearchParams(newParams)
  }

  // `https://login.${process.env.BEEHIVELY_DOMAIN}/login?sid=${school.subdomain}`
  return (
    <AnimatePresence>
      <MotionStack
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        width="100%"
        height="calc(100vh - 5.4rem)"
        overflowY="auto"
      >
        <Heading fontWeight={300} color="teal.500" margin={3}>
          {school.name}
          {school.createdAt ? (
            <Text fontSize="xs" color="black">
              Created on{' '}
              {moment(school.createdAt).calendar({ sameElse: 'YYYY-MM-DD' })}
            </Text>
          ) : null}
          {login ? (
            <SupportLoginCell
              id={school.id}
              name={school.name}
              from="schoolCell"
            />
          ) : (
            <Button
              colorScheme="teal"
              marginTop={3}
              onClick={(e) => {
                e.preventDefault()
                setLogin(true)
                setTimeout(() => setLogin(false), 3000)
              }}
              variant="outline"
            >
              Log in {rightArrow}
            </Button>
          )}
          {threelogin ? (
            <SupportLoginCell
              id={school.id}
              name={school.name}
              three={true}
              from="schoolCell"
            />
          ) : (
            <Button
              colorScheme="teal"
              marginTop={3}
              onClick={(e) => {
                e.preventDefault()
                setThreeLogin(true)
                setTimeout(() => setThreeLogin(false), 3000)
              }}
              variant="outline"
            >
              [3] Log in{rightArrow}
            </Button>
          )}
          <SchoolEditModal
            isOpen={isOpen}
            onClose={handleClose}
            school={school}
            trigger={
              <Button
                colorScheme="teal"
                marginTop={3}
                marginLeft={3}
                onClick={(e) => {
                  e.preventDefault()
                  openEdit()
                }}
                variant="outline"
              >
                Edit
              </Button>
            }
          />
        </Heading>
        <Tabs index={Number(tab || 0)} onChange={handleTabChange}>
          <TabList>
            {tabs.map((t) => (
              <Tab key={t}>{t}</Tab>
            ))}
          </TabList>

          <TabPanels>
            <TabPanel>
              <SchoolDash
                school={school}
                contents={contents}
                people={people}
                last30={people30days}
              />
            </TabPanel>
            <TabPanel>
              <LogCell page={1} schoolId={school.id} />
            </TabPanel>
            <TabPanel>
              <SchoolSitesCell id={id} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </MotionStack>
    </AnimatePresence>
  )
}

export const Loading = CellLoading

export const Empty = () => <Success />

export const Failure = ({ error }) => <div>Error: {error.message}</div>
